import isEmpty from 'lodash/isEmpty';
import * as Yup from 'yup';

import { FORM_VALIDATION_ERRORS } from 'src/consts';

import { getIndexOfNestedFieldArray } from '../utils';

const ATTRIBUTES = 'attributes';

export const medicationsFieldArrayValidation = Yup.array()
  .of(
    Yup.object().shape({
      /** @see https://codesandbox.io/s/8x1r034mr9 */
      name: Yup.string().test(
        'is-selected-medication-from-dropdown',
        FORM_VALIDATION_ERRORS.selectValidMedication,
        function () {
          // The way MedicationsFieldArray works now does
          // not require form validation, since the user can only
          // add medications from the dropdown, and we'll take care
          // of the empty values when submitting.

          // This validation is here to avoid moving something we
          // don't need to move and for future-proofing.

          const path = this.path;
          const medIndex = getIndexOfNestedFieldArray(path);
          if (medIndex == 0) {
            return true; // pass validation for first, empty object
          } else {
            const attributes = this.parent[ATTRIBUTES];
            // returning `false` results in the error message above
            return !isEmpty(attributes);
          }
        }
      ),
      attributes: Yup.object(),
    })
  )
  .when('shouldTransferAllMeds', {
    is: true, // When shouldTransferAllMeds is true
    then: Yup.array().notRequired(), // Make medications optional
    otherwise: Yup.array().min(2, FORM_VALIDATION_ERRORS.selectMedication), // Keep the original validation when false
  });
